import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Table, TableModule } from "primeng/table";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { distinctUntilChanged } from "rxjs";
import { CommonModule, DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ProductionWorkflowLineDto } from "../../../core/models/project-workflow/productionWorkflowLineDto";
import { WorkflowStatusDto } from "../../../core/models/project-workflow/workflowStatusDto";
import { AddTaskNotes } from "../../../core/models/task-management/addTaskNotesDto";
import { AddTaskRequestDto } from "../../../core/models/task-management/addTaskRequestDto";
import { GetAllTaskResponse } from "../../../core/models/task-management/getAllTaskResponseDto";
import { UpdateTaskRequestDto } from "../../../core/models/task-management/updateTaskDto";
import { SharedService } from "../../../core/services/shared.service";
import { PriorityTypeEnums } from "../../../shared/enums/priorityTypeEnum";
import { EnumSalesTaskStatus } from "../../../shared/enums/salesTaskStatus";
import { TaskTypeEnum } from "../../../shared/enums/taskTypeEnum";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import { TaskManagementService } from "../../../core/services/task-management.service";
import { replaceString } from "../../../shared/globalfunction";
import { DatePickerModule } from "primeng/datepicker";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { WorkflowLineNotesComponent } from "../workflow-line-notes/workflow-line-notes.component";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { TaskHeaderComponent } from "../../../shared/components/task-header/task-header.component";
import { AddProjectWorkflowLineNotesDto } from "../../../core/models/project-workflow/addProjectWorkflowLineNotesDto";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { GetBCForSalesOrderDto } from "../../../core/models/orders/getBCForSalesOrderDto";
import { TaskHeaderEditComponent } from "../../task-management/task-header-edit/task-header-edit.component";
import { TooltipModule } from "primeng/tooltip";

@UntilDestroy()
@Component({
  selector: "jni-project-task-list",
  templateUrl: "./project-task-list.component.html",
  styleUrls: ["./project-task-list.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DatePickerModule,
    SelectModule,
    ReactiveFormsModule,
    FormsModule,
    WorkflowLineNotesComponent,
    DialogModule,
    ConfirmDialogComponent,
    SpinnerComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    TaskHeaderComponent,
    TaskHeaderEditComponent,
    TooltipModule,
  ],
})
export class ProjectTaskListComponent implements OnInit, OnChanges {
  @Input() workflowId = 0;
  @Input() taskType = 0;
  @Input() clientAccountNumber = "";
  @Input() userList = [] as { personnelNumber: string; name: string }[];
  @Input() isDisableLink = false;
  @Input() salesTaskSmallLoader = false;
  @Input() jobName = "";
  @Input() orderInHandDate = "";
  @Input() taskList = [] as GetAllTaskResponse[];
  @Input() productionStatusList = [] as WorkflowStatusDto[];

  @Output() refreshGridEvent = new EventEmitter();
  @Output() refreshLineItemGridEvent = new EventEmitter();
  @Output() hasUnsavedChangesEvent = new EventEmitter<boolean>();

  expandSalesTaskListStatus = true;
  collapseSalesTaskHeading = "Expand all";
  collapseSalesTaskStatus = false;

  displayTaskNoteSideBar = false;
  type = "Task";
  noteTaskId = 0;
  taskNote = "";
  statusList = [] as { name: string; value: number }[];
  priorityList = [] as { name: string; value: number }[];
  showEdit = true;
  @ViewChild("dtTaskList") table!: Table;
  isAdd = false;
  isEdit = false;
  selectedRowIndex: number | null = null;
  taskForm!: FormGroup;
  // selectedRow: OtherCertificates = {};
  taskIdSelected = 0;
  formType = "";
  defaultTask = false;
  taskTypes = [
    {
      id: 1,
      title: "Sales Task",
    },
    {
      id: 2,
      title: "Production Task",
    },
  ];
  priorityLevel = [
    {
      id: 1,
      title: "Urgent",
      production: true,
    },
    {
      id: 2,
      title: "Order",
      production: false,
    },
    {
      id: 3,
      title: "Source",
      production: false,
    },
    {
      id: 4,
      title: "Standard",
      production: true,
    },
  ];
  defaultTaskValues: GetAllTaskResponse = {
    projectWorkflowId: this.workflowId,
    taskId: 0,
    title: "",
    description: "",
    client: "",
    clientName: "",
    jobName: this.jobName,
    assignedTo: "",
    createdBy: "",
    taskPaddedId: null,
    salesOrderId: "",
    taskType: this.taskType,
    priorityType: 0,
    status: 0,
    statusText: "",
    dueDate: "",
    createdDate: "",
    tags: [],
    attachmentCount: 0,
    commentsCount: 0,
    ihd: this.orderInHandDate,
    esd: "",
    notes: "",
    owner: "",
    taskTypeText: "",
    sortOrder: 0,
    priorityTypeText: "",
    isExternal: false,
    isAdmin: false,
    isEditable: false,
    empPersonalNumber: "",
    nickName: "",
    poNumber: "",
    supplierName: "",
    dueDatePassed: false,
    lineRecId: 0,
    isArchived: false,
    shipDateD365: "",
    trackingsDeliveryDate: "",
    isFirmInHand: false,
    trackingCount: 0,
    calendarDueDate: undefined,
    buyerName: "",
    remindMe: "",
    orignalOrder: 0,
    assignedToEmail: "",
  };
  priorityLevelFiltered: { id: number; title: string; production: boolean }[] =
    [];

  @ViewChild("taskHeaderEdit", { static: false })
  taskHeaderEdit!: TaskHeaderEditComponent;

  showNewTaskModal = false;
  currentdate = new Date();
  @Output() triggerContact = new EventEmitter<string>();
  @Input() buyerName = "";
  displayTaskDetailModal = false;
  //workflowStatusList: any;

  private taskStatusKeyPairsSales: Record<number, string> = {
    [EnumSalesTaskStatus.New]: "New",
    [EnumSalesTaskStatus.Blocked]: "Blocked",
    [EnumSalesTaskStatus.InProgress]: "In Progress",
    [EnumSalesTaskStatus.InReview]: "In Review",
    [EnumSalesTaskStatus.Closed]: "Closed",
  };

  private taskStatusKeyPairsProduction: Record<number, string> = {
    [WorkflowStatusEnum.ALL]: "All",
    [WorkflowStatusEnum.Cancelled]: "Cancelled",
    [WorkflowStatusEnum.Complete]: "Complete",
    [WorkflowStatusEnum.Delivered]: "Delivered",
    [WorkflowStatusEnum.InProduction]: "In Production",
    [WorkflowStatusEnum.OrderWritten]: "Order Written",
    [WorkflowStatusEnum.PoSent]: "Po Sent",
    [WorkflowStatusEnum.ProjectCreated]: "Project Created",
    [WorkflowStatusEnum.ProofApproved]: "Proof Approved",
    [WorkflowStatusEnum.ProofSent]: "Proof Sent",
    [WorkflowStatusEnum.RevisionRequested]: "Revision Requested",
    [WorkflowStatusEnum.Shipped]: "Shipped",
  };

  private taskStatusKeyPairsSalesByName: Record<string, number> = {
    New: EnumSalesTaskStatus.New,
    Blocked: EnumSalesTaskStatus.Blocked,
    "In Progres": EnumSalesTaskStatus.InProgress,
    "In Review": EnumSalesTaskStatus.InReview,
    Closed: EnumSalesTaskStatus.Closed,
  };

  archiveMessage = "You want to mark <b>{0}</b> as {1}.";
  archiveAlertVisible = false;
  archivedTask = 0;
  archivedTaskStatus = false;

  displayAddTaskModal = false;
  showTaskModal = false;
  ownerList: { name: string; personnelNumber: string }[] = [];
  currentUserName = "";
  constructor(
    private _sharedService: SharedService,
    private _toastr: JniToastrService,
    private _taskManagementService: TaskManagementService,
    private _formBuilder: FormBuilder,
    private _dataPipe: DatePipe,
    private _router: Router,
    private _samplepoListingService: SamplepoListingService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.getPriorityList();
    this.getStatusList();
    this.populatePriorityList();
    this.getOwnersByProject(this.clientAccountNumber);
    if (this.taskForm) {
      this.taskForm.valueChanges.subscribe(() => {
        this.hasUnsavedChangesEvent.emit(true);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.["buyerName"] !== undefined &&
      changes?.["buyerName"].currentValue !==
        changes?.["buyerName"].previousValue
    ) {
      this.buyerName = changes["buyerName"].currentValue;
    }
    if (
      changes?.["clientAccountNumber"] !== undefined &&
      changes?.["clientAccountNumber"].currentValue !==
        changes?.["clientAccountNumber"].previousValue
    ) {
      this.clientAccountNumber = changes["clientAccountNumber"].currentValue;
      this.getOwnersByProject(this.clientAccountNumber);
    }
  }

  private initializeForm() {
    this.taskForm = this._formBuilder.group({
      parentTask: this._formBuilder.group({
        title: ["", [Validators.required, Validators.maxLength(256)]],
        taskType: ["", Validators.required],
        description: [""],
      }),
      subTask: this._formBuilder.group({
        project: ["", Validators.required],
        client: [{ value: "", disabled: true }, Validators.required],
        jobName: [{ value: "", disabled: true }, Validators.required],
        ihd: [{ value: "" }],
        purchaseOrderNumber: [{ value: "", disabled: true }],
        supplier: [{ value: "", disabled: true }],
        esd: [{ value: "" }],
        dueDate: ["", Validators.required],
        nickName: [{ value: "" }],
        priority: [4],
        assignedTo: [""],
        taskStatus: [""],
        lineRecId: [0],
      }),
    });

    this.taskForm
      .get("parentTask.taskType")
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe(taskType => {
        const type = this.taskTypes.find(it => it.id == taskType);
        if (type) {
          this.formType = type.title;
          if (type.id === 2) {
            this.priorityLevelFiltered = this.priorityLevel.filter(
              item => item.production === true
            );
          } else {
            this.priorityLevelFiltered = this.priorityLevel;
          }
          // this.setDynamicValidation(this.formType);
          // this.patchEmptyForm();
        }
      });

    if (this.taskType === TaskTypeEnum.Sales) {
      this.taskForm.get(["subTask", "nickName"])?.clearValidators();
      this.taskForm.get(["subTask", "nickName"])?.updateValueAndValidity();
    }
  }

  patchFormForEditTask(taskDetail: GetAllTaskResponse) {
    const priorityPatch = this.priorityLevel.find(
      item => item.id === taskDetail.priorityType
    );
    // this.selectedTags = taskDetail.tags;
    const taskPatch = this.taskTypes.find(
      (item: { id: number; title: string }) => item.id == taskDetail.taskType
    );
    this.taskForm.patchValue({
      parentTask: {
        title: taskDetail.title,
        taskType: taskDetail.taskType,
        description: taskDetail.description,
      },
      subTask: {
        project: this.workflowId.toString().padStart(6, "0"),
        assignedTo: taskDetail.assignedTo,
        priority: priorityPatch?.title,
        // remindMe: new Date(taskDetail.remindMe),
        // tag: taskDetail.tags,
        dueDate: new Date(taskDetail.dueDate),
        taskType: taskPatch?.title,
        client: taskDetail.client,
        linkedOrder: taskDetail.salesOrderId,
        nickName: taskDetail.nickName,
        jobName: taskDetail.taskType === 1 ? taskDetail.jobName : null,
        ihd: taskDetail.ihd ? new Date(taskDetail.ihd) : null,
        esd: taskDetail.esd ? new Date(taskDetail.esd) : null,
      },
    });
  }

  editLine(taskId: number) {
    this.isAdd = false;
    this.cancelAllEditRow();
    this.taskIdSelected = taskId;
    const row = this.table.value.filter(x => x.taskId === taskId);
    if (row.length > 0) {
      this.patchFormForEditTask(row[0]);
      this.table.initRowEdit(row[0]);
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  addTask() {
    if (this.taskForm.invalid) {
      this.taskForm.markAllAsTouched();
      this._toastr.error("Error", "Kindly Fill all required Fields");
      return;
    }

    const region = Intl.DateTimeFormat().resolvedOptions().locale;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (this.taskForm.valid) {
      this.showNewTaskModal = false;
      this.salesTaskSmallLoader = true;
      const formValue = this.taskForm.value;
      const addTaskReqBody = {
        title: formValue.parentTask.title,
        assignedTo: formValue.subTask.assignedTo ?? "",
        description: "",
        dueDate: this._dataPipe.transform(
          formValue.subTask.dueDate,
          "MM/dd/yyyy"
        ),
        priorityType: formValue.subTask.priority,
        projectWorkflowId: this.workflowId,
        // salesOrderLineRecIdD365: 0,
        taskType: this.taskType,
        taskStatus: formValue.subTask.taskStatus,
        region: region ?? "",
        timeZone: timezone ?? "",
        salesOrderLineRecIdD365: formValue.subTask.lineRecId,
        ihd: this._dataPipe.transform(formValue.subTask.ihd, "MM/dd/yyyy"),
        nickName: formValue.subTask.nickName,
      } as AddTaskRequestDto;
      this._taskManagementService
        .addTask(addTaskReqBody)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.status.toLowerCase() == "success") {
              this._toastr.success("Success", "Task Created Successfully!");
              this.isAdd = false;
            } else {
              this._toastr.error("Error", "Error creating task");
            }
            this.salesTaskSmallLoader = false;
            this.taskForm.reset();
            this.refreshGridEvent.emit();
            if (this.taskType === TaskTypeEnum.Production) {
              this.refreshLineItemGridEvent.emit();
            }
            this.hasUnsavedChangesEvent.emit(false);
          },
          error: () => {
            this._toastr.error("Error", "Error creating task");
            this.salesTaskSmallLoader = false;
            this.taskForm.reset();
            this.refreshGridEvent.emit();
          },
        });
    }
  }

  onRowEditSave(task: GetAllTaskResponse) {
    if (this.taskForm.valid) {
      this.salesTaskSmallLoader = true;
      const formValue = this.taskForm.value;
      let priorityObj;
      if (typeof formValue.subTask.priority == "string") {
        priorityObj = this.priorityLevel.find(
          item => formValue.subTask.priority === item.title
        );
      } else {
        priorityObj = this.priorityLevel.find(
          item => formValue.subTask.priority === item.id
        );
      }
      const updateTaskReq = {
        title: formValue.parentTask.title,
        assignedTo: formValue.subTask.assignedTo,
        description: formValue.parentTask.description,
        dueDate: this._dataPipe.transform(
          formValue.subTask.dueDate,
          "MM/dd/yyyy"
        ),
        priorityType: priorityObj?.id,
        taskId: this.taskIdSelected,
        ihd: this._dataPipe.transform(formValue.subTask.ihd, "MM/dd/yyyy"),
        projectWorkflowId: this.workflowId,
        esd: this._dataPipe.transform(formValue.subTask.esd, "MM/dd/yyyy"),
        nickName: formValue.subTask.nickName,
        jobNameD365: task.jobName,
        customerIdD365: task.client,
        saleOrderId: task.salesOrderId,
        remindMe: this._dataPipe.transform(
          task.remindMe,
          "MM/dd/yyyy HH:mm:ss"
        ),
        buyer: task.buyerName,
        status: task.status,
      } as UpdateTaskRequestDto;
      this._taskManagementService
        .updateTask(updateTaskReq)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res && res.status.toLowerCase() == "success") {
              const taskStatus = task.status;
              this.updateTaskStatus(taskStatus, this.taskIdSelected);
            } else {
              this._toastr.error("Error", "Unable to Update Task");
              this.salesTaskSmallLoader = false;
              this.refreshGridEvent.emit();
            }
            this.hasUnsavedChangesEvent.emit(false);
          },
          error: () => {
            this._toastr.error("Error", "Unable to Update task");
            this.salesTaskSmallLoader = false;
            this.refreshGridEvent.emit();
          },
        });
    }
  }

  refreshGrid() {
    this.isAdd = false;
    this.isEdit = false;
    this.cancelAllEditRow();
    this.refreshGridEvent.emit();
    this.hasUnsavedChangesEvent.emit(false);
  }

  getPriorityList() {
    this.priorityList = this._sharedService.enumToList(PriorityTypeEnums);
  }

  onTaskToggle() {
    if (this.expandSalesTaskListStatus) {
      this.collapseSalesTaskStatus = true;
      this.expandSalesTaskListStatus = false;
      this.collapseSalesTaskHeading = "Collapse all";
    } else {
      this.collapseSalesTaskStatus = false;
      this.expandSalesTaskListStatus = true;
      this.collapseSalesTaskHeading = "Expand all";
    }
  }

  addSalesTaskRowPreview() {
    this.taskIdSelected = 0;
    this.displayTaskDetailModal = true;
    //this.collapseSalesTaskStatus = true;
    //this.expandSalesTaskListStatus = false;
    //this.collapseSalesTaskHeading = "Collapse all";
    //this.isAdd = true;
    //this.cancelAllEditRow();
    //this.taskForm.reset();
    //if (this.taskList.length === 0) {
    //  this.defaultTask = true;
    //  this.defaultTaskValues.jobName = this.jobName;
    //  this.defaultTaskValues.ihd = this.orderInHandDate;
    //  this.defaultTaskValues.projectWorkflowId = this.workflowId;
    //  this.defaultTaskValues.client = this.clientAccountNumber;
    //  this.taskList.push(this.defaultTaskValues);
    //}
    //this.taskForm.patchValue({
    //  parentTask: {
    //    taskType: this.taskType,
    //  },
    //  subTask: {
    //    project: this.workflowId,
    //    taskStatus: EnumSalesTaskStatus.New,
    //  },
    //});
  }

  closeSideBarForNotes() {
    this.displayTaskNoteSideBar = false;
  }

  saveTaskNotes(event: AddProjectWorkflowLineNotesDto) {
    const payload: AddTaskNotes = {
      notes: event.notes,
      taskId: event.taskId ?? 0,
    };
    this.salesTaskSmallLoader = true;
    this._taskManagementService
      .addTaskNotes(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this._toastr.success("Success", "Notes Added Successfully");
          } else {
            this._toastr.error("Error", "Failed to Add Notes");
          }
          this.salesTaskSmallLoader = false;
          this.closeSideBarForNotes();
          this.refreshGrid();
        },
        error: () => {
          this._toastr.error("Error", "Failed to Add Notes");
          this.salesTaskSmallLoader = false;
        },
      });
  }

  showTaskNoteSideBar(taskId: number, note: string) {
    this.noteTaskId = taskId;
    this.taskNote = note;
    this.displayTaskNoteSideBar = true;
  }

  getStatusList() {
    if (this.taskType === TaskTypeEnum.Production) {
      this.statusList = this.productionStatusList.reduce(
        (item: { name: string; value: number }[], obj: WorkflowStatusDto) => {
          if (obj.id !== WorkflowStatusEnum.ProjectCreated) {
            item.push({
              name: obj.status,
              value: obj.id,
            } as { name: string; value: number });
          }

          return item;
        },
        [] as { name: string; value: number }[]
      );
    } else {
      this.statusList = this._sharedService.enumToList(
        this.taskStatusKeyPairsSalesByName
      );
    }
  }

  getTaskStatusTitleSales(taskStatus: number) {
    return this.taskStatusKeyPairsSales[taskStatus];
  }

  getTaskStatusTitleProduction(taskStatus: number) {
    return this.taskStatusKeyPairsProduction[taskStatus];
  }

  renderUsers(
    users: {
      personnelNumber: string;
      name: string;
    }[]
  ) {
    const uniqueUsers = new Map();
    users.forEach((user: { personnelNumber: string; name: string }) => {
      uniqueUsers.set(user.personnelNumber, user);
    });

    return Array.from(uniqueUsers.values());
  }

  isFieldInvalid(form: string, fieldName: string) {
    const control = this.taskForm.get(form + "." + fieldName);

    return control?.invalid && (control?.dirty || control?.touched);
  }

  addProductionTaskRowPreview(event: ProductionWorkflowLineDto) {
    //this.isAdd = true;
    this.taskForm.patchValue({
      parentTask: {
        taskType: this.taskType,
      },
      subTask: {
        purchaseOrderNumber: event.purchaseOrderD365,
        nickName: event.nickName,
        ihd: event?.inHandDate ? new Date(event.inHandDate) : null,
        supplier: event.vendorNameD365,
        project: this.workflowId,
        taskStatus:
          this.taskType === 2
            ? (event.lineStatus ?? WorkflowStatusEnum.OrderWritten)
            : EnumSalesTaskStatus.New,
        lineRecId: event.lineRecIdD365 ?? 0,
        esd: event.shipDateD365,
        assignedTo: this.currentUserName,
        priority: 4,
        //esd: event.esd
      },
    });

    this.userList = this.ownerList;
    this.showNewTaskModal = true;
  }

  redirectToTaskSummary(taskId: number) {
    if (taskId) {
      // const url = this._router.serializeUrl(
      //   this._router.createUrlTree([`/task-management/task-detail/${taskId}`])
      // );
      // window.open(url, "_blank");
      this.taskIdSelected = taskId;
      this.displayTaskDetailModal = true;
    }
  }

  onHideNewTaskModal() {
    this.showNewTaskModal = false;
  }

  updateTaskStatus(status: number, taskId: number) {
    this.salesTaskSmallLoader = true;
    this._taskManagementService
      .updateStatus(taskId, status)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data && res.status.toLowerCase() === "success") {
            this._toastr.success("Success", "Task Updated Successfully!");
          } else {
            this._toastr.error("Error", "Unable to Update Task Status");
          }
          this.salesTaskSmallLoader = false;
          this.refreshGridEvent.emit();
          if (this.taskType === TaskTypeEnum.Production) {
            this.refreshLineItemGridEvent.emit();
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to Update Task Status");
          this.salesTaskSmallLoader = false;
          this.refreshGridEvent.emit();
        },
      });
  }

  updateTaskDateField(fieldPath: string, value: string) {
    this.hasUnsavedChangesEvent.emit(true);
    // If value is empty/null, set current date for the date picker to show current date as default
    const updatedValue =
      value && value !== "" && value !== null && value !== undefined
        ? new Date(value)
        : new Date(); // Use current date instead of empty string
    this.taskForm.patchValue(this.createNestedObject(fieldPath, updatedValue));
  }

  // private createNestedObject(path: string, value: Date | string) {
  //   return path
  //     .split(".")
  //     .reduceRight<any>((acc, key) => ({ [key]: acc }), value);
  // }

  private createNestedObject(
    path: string,
    value: string | Date
  ): Record<string, unknown> {
    return path
      .split(".")
      .reduceRight<
        Record<string, unknown>
      >((acc, key) => ({ [key]: acc }), value as unknown as Record<string, unknown>);
  }

  populatePriorityList() {
    if (this.taskType === 2) {
      this.priorityLevelFiltered = this.priorityLevel.filter(
        item => item.production === true
      );
    } else {
      this.priorityLevelFiltered = this.priorityLevel;
    }
  }

  onSingleFieldEdit(
    task: GetAllTaskResponse,
    field: string,
    value: Date | FocusEvent | SelectChangeEvent
  ) {
    this.salesTaskSmallLoader = true;
    const updateTaskReq = {
      title: task.title,
      assignedTo: task.assignedTo,
      description: task.description,
      dueDate: this._dataPipe.transform(task.dueDate, "MM/dd/yyyy"),
      priorityType: task.priorityType,
      taskId: task.taskId,
      ihd: this._dataPipe.transform(task.ihd, "MM/dd/yyyy"),
      projectWorkflowId: this.workflowId,
      esd: this._dataPipe.transform(task.esd, "MM/dd/yyyy"),
      nickName: task.nickName,
      jobNameD365: task.jobName,
      customerIdD365: task.client,
      saleOrderId: task.salesOrderId,
      remindMe: this._dataPipe.transform(task.remindMe, "MM/dd/yyyy HH:mm:ss"),
      buyer: task.buyerName,
      status: task.status,
    } as UpdateTaskRequestDto;

    switch (field) {
      case "esd":
        updateTaskReq.esd =
          this._dataPipe.transform(value as unknown as string, "MM/dd/yyyy") ??
          "";
        break;
      case "ihd":
        updateTaskReq.ihd =
          this._dataPipe.transform(value as unknown as string, "MM/dd/yyyy") ??
          "";
        break;
      case "dueDate":
        updateTaskReq.dueDate =
          this._dataPipe.transform(value as unknown as string, "MM/dd/yyyy") ??
          "";
        break;
      case "title": {
        const target = (value as unknown as FocusEvent)
          .target as HTMLInputElement;
        updateTaskReq.title = target?.value ?? "";
        break;
      }
      case "priority":
        if ("value" in value) {
          updateTaskReq.priorityType = Number(value.value);
        }
        break;
      case "assignedTo":
        if ("value" in value) {
          updateTaskReq.assignedTo = String(value.value);
        }
        break;
    }

    this._taskManagementService
      .updateTask(updateTaskReq)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res && res.status.toLowerCase() == "success") {
            if (field === "status") {
              if ("value" in value) {
                const taskStatus = Number(value.value);
                this.updateTaskStatus(taskStatus, updateTaskReq.taskId);
              }
            } else {
              this._toastr.success("Success", "Task Updated Successfully!");
              this.refreshGridEvent.emit();
            }
          } else {
            this._toastr.error("Error", "Unable to Update Task");
            this.salesTaskSmallLoader = false;
            this.refreshGridEvent.emit();
          }
          this.hasUnsavedChangesEvent.emit(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to Update task");
          this.salesTaskSmallLoader = false;
          this.refreshGridEvent.emit();
        },
      });
  }

  onInputChange() {
    this.hasUnsavedChangesEvent.emit(true);
  }

  archiveEvent(task: GetAllTaskResponse, status: boolean) {
    const eventTxt = status ? "Archived" : "UnArchived";
    this.archiveMessage = replaceString(
      this.archiveMessage,
      task.title,
      eventTxt
    );
    this.archivedTask = task.taskId;
    this.archivedTaskStatus = status;
    this.archiveAlertVisible = true;
  }

  confirmArchive(event: boolean) {
    this.archiveAlertVisible = false;
    this.archiveMessage = "You want to mark <b>{0}</b> as {1}.";
    if (event && this.archivedTask) {
      const payload = {
        taskId: this.archivedTask,
        archive: this.archivedTaskStatus,
      };
      this._taskManagementService.MarkAsArchive(payload).subscribe({
        next: async res => {
          if (res && res.status.toLowerCase() === "success") {
            this._toastr.success(
              "Success",
              "Task archive status has been changed"
            );
            this.refreshGrid();
          } else {
            this._toastr.error("Error", "Failed to Update Task");
          }
        },
        error: () => {
          this._toastr.error("Error", "Failed to Update Task");
        },
      });
    }
  }

  getLineIHDClass(task: GetAllTaskResponse) {
    const today = new Date().setHours(0, 0, 0, 0);
    const inHandDate = task.ihd
      ? new Date(task.ihd).setHours(0, 0, 0, 0)
      : null;
    if (
      task.taskType === TaskTypeEnum.Sales &&
      inHandDate &&
      inHandDate < today
    ) {
      return "danger";
    }
    if (task.taskType === TaskTypeEnum.Production) {
      const shipDate = task.shipDateD365
        ? new Date(task.shipDateD365).setHours(0, 0, 0, 0)
        : null;
      const deliveredDate = task.trackingsDeliveryDate
        ? new Date(task.trackingsDeliveryDate).setHours(0, 0, 0, 0)
        : today;
      if (
        task.isFirmInHand &&
        ((inHandDate && inHandDate < deliveredDate && task.trackingCount > 0) ||
          (inHandDate && inHandDate < deliveredDate) ||
          (shipDate && inHandDate && shipDate > inHandDate))
      ) {
        return "firm-danger";
      } else if (
        task.isFirmInHand ||
        (inHandDate && inHandDate < deliveredDate && task.trackingCount > 0) ||
        (inHandDate && inHandDate < deliveredDate) ||
        (shipDate && inHandDate && shipDate > inHandDate)
      ) {
        return "danger";
      } else if (
        task.shipDateD365 &&
        task.shipDateD365 != "" &&
        task.trackingCount !== 0 &&
        (!task.ihd || task.ihd === "")
      ) {
        return "warning";
      }
    }
    return "";
  }

  closeAddTask() {
    this.displayAddTaskModal = false;
    this.refreshGridEvent.emit();
    this.collapseSalesTaskStatus = true;
    this.expandSalesTaskListStatus = false;
    this.collapseSalesTaskHeading = "Collapse all";
  }

  showContactDialog(client: string) {
    this.triggerContact.emit(client);
  }

  getOwnersByProject(client: string) {
    if (client) {
      this._samplepoListingService.getBCForSalesOrder(client).subscribe({
        next: (res: GenericResponseDto<GetBCForSalesOrderDto[]>) => {
          this.ownerList = [];
          if (res.data != null && res.data.length > 0) {
            res.data.forEach((item: GetBCForSalesOrderDto) => {
              if (item.projectName) {
                const user = {
                  name: item.projectName,
                  personnelNumber: item.personnelNumber,
                };
                this.ownerList.push(user);
                if (item.isCurrentUser) {
                  this.currentUserName = item.projectName;
                }
                this.getBacForSalesOrder(item.personnelNumber);
              }
            });
          }
        },
      });
    }
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._samplepoListingService
      .getBacForSalesOrder(personnelNumber)
      .subscribe({
        next: res => {
          if (res.data != null && res.data.length > 0) {
            res?.data.map(item => {
              if (item.name != "") {
                this.ownerList?.push({
                  name: item.name,
                  personnelNumber: item.personnelNumber,
                });
                if (item.isCurrentUser) {
                  this.currentUserName = item.name;
                }
              }
            });
          }
        },
      });
  }

  closeTaskDetailModal() {
    this.displayTaskDetailModal = false;
    this.refreshGridEvent.emit();
  }

  onTitleBlur(task: GetAllTaskResponse, event: FocusEvent) {
    // Use setTimeout to let click events complete first
    setTimeout(() => {
      // Check if modal opened (meaning user clicked the link)
      if (!this.displayTaskDetailModal) {
        this.onSingleFieldEdit(task, "title", event);
      }
    }, 50);
  }

  refreshBuyerGridList() {
    if (this.taskHeaderEdit) {
      this.taskHeaderEdit?.refreshBuyerGridList();
    }
  }
}
